import React, { useState, useEffect } from "react";
import "./CategoryManager.css";
import { ensureAbsoluteUrl } from "../../utils"; // Ajusta la ruta según tu estructura
import { API_BASE_URL } from "../../config";

const CategoryManager = () => {
  const [mainCategories, setMainCategories] = useState([]);
  const [cloverCategories, setCloverCategories] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState(null);
  const [selectedCloverCategories, setSelectedCloverCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [configuraciones, setConfiguraciones] = useState({
    logo: "",
  });

  const cliente_id = localStorage.getItem("cliente_id");
  const merchant_id = localStorage.getItem("merchant_id");
  const defaultImage = "static/images/default-logo.png";
const [subcategoryPositions, setSubcategoryPositions] = useState({});

// Función para actualizar posiciones de subcategorías en el modal
const handlePositionChange = (categoryId, position) => {
  setSubcategoryPositions((prev) => ({
    ...prev,
    [categoryId]: position,
  }));
};

// Efecto que carga posiciones al abrir el modal
useEffect(() => {
  if (selectedMainCategory) {
    const mainCategory = mainCategories.find(cat => cat.id === selectedMainCategory);
    if (mainCategory && mainCategory.subcategories) {
      const positions = {};
      mainCategory.subcategories.forEach(subcat => {
        positions[subcat.clover_category_id] = subcat.position || 0;
      });
      setSubcategoryPositions(positions);
    }
  }
}, [selectedMainCategory]);



useEffect(() => {


  const fetchConfiguraciones = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/configuraciones`);
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const data = await response.json();
      setConfiguraciones(data); // Poblar configuraciones
    } catch (error) {
      console.error("Error al cargar configuraciones:", error);
    }
  };

  fetchConfiguraciones();
  fetchMainCategories();
  fetchCloverCategories();
  fetchProducts();
  syncCloverData(); // Sincroniza datos automáticamente al cargar
}, [])

const fetchMainCategories = async () => {
  if (!cliente_id) {
    console.error("❌ cliente_id no está definido");
    return;
  }

  try {
    setLoading(true);

    // 🔥 Obtener el logo predeterminado
    const logoResponse = await fetch(`${API_BASE_URL}/configuraciones`);
    let defaultLogo = "static/images/default-logo.png";

    if (logoResponse.ok) {
      const configData = await logoResponse.json();
      defaultLogo = configData.logo
        ? ensureAbsoluteUrl(configData.logo)
        : ensureAbsoluteUrl(defaultLogo);
    }

    // 🔥 Obtener categorías principales
    const response = await fetch(`${API_BASE_URL}/categories?cliente_id=${cliente_id}`);
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

    const data = await response.json();
    console.log("📌 Categorías recibidas al refrescar:", data.categorias);

    // 🔍 Verifica qué imagen está devolviendo la API después de la actualización
    data.categorias.forEach(cat => {
      console.log(`🖼️ Imagen de ${cat.name}: ${cat.image_path}`);
    });

    // 🔥 Eliminar duplicados asegurando IDs únicos
    const uniqueCategories = [];
    const categoryIds = new Set();

    (data.categorias || []).forEach((category) => {
      if (!categoryIds.has(category.id)) {
        categoryIds.add(category.id);
        uniqueCategories.push({
          ...category,
          image_path: category.image_path
            ? ensureAbsoluteUrl(`${category.image_path}?t=${new Date().getTime()}`) // 🔥 Evita caché
            : defaultLogo,
          subcategories: category.subcategories || [], // ✅ Evita undefined
        });
      }
    });

    setMainCategories(uniqueCategories);
  } catch (error) {
    console.error("❌ Error al cargar categorías principales:", error);
    setMessage("Error al cargar categorías principales.");
  } finally {
    setLoading(false);
  }
};

  const fetchCloverCategories = async () => {
    if (!cliente_id) {
      console.error("Error: cliente_id no está definido.");
      setMessage("Error: No se pudo obtener el ID del cliente.");
      return;
    }

    setLoading(true);

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000);

      const response = await fetch(
        `${API_BASE_URL}/clover/categories?cliente_id=${cliente_id}`,
        { signal: controller.signal }
      );

      clearTimeout(timeoutId);

      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

      const data = await response.json();
      setCloverCategories(data.categorias || []);
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("Error: La solicitud fue abortada por timeout.");
        setMessage("Error: El servidor no respondió a tiempo. Intente nuevamente.");
      } else {
        console.error("Error al cargar categorías de Clover:", error);
        setMessage("Error al cargar categorías de Clover.");
      }
    } finally {
      setLoading(false);
    }
  };

  const addMainCategory = async () => {
    if (!newCategory.trim()) {
      setMessage("El nombre de la categoría es obligatorio.");
      return;
    }

    if (!cliente_id || !merchant_id) {
      setMessage("Error: Cliente o Merchant no identificado.");
      return;
    }

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000);

      const logoResponse = await fetch(`${API_BASE_URL}/configuraciones`, {
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      let defaultLogo = "static/images/default-logo.png";
      if (logoResponse.ok) {
        const configData = await logoResponse.json();
        defaultLogo = configData.logo
          ? ensureAbsoluteUrl(configData.logo)
          : ensureAbsoluteUrl(defaultLogo);
      }

      const data = {
        name: newCategory,
        merchant_id,
        cliente_id,
        image_path: defaultLogo,
      };

      const response = await fetch(`${API_BASE_URL}/categories`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

      setMessage("Categoría creada exitosamente.");
      setNewCategory("");
      fetchMainCategories();
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("La solicitud fue abortada debido a un timeout.");
        setMessage("El servidor no respondió a tiempo. Intente nuevamente.");
      } else {
        console.error("Error al crear categoría:", error);
        setMessage("Hubo un error al crear la categoría.");
      }
    }
  };

const assignSubCategories = async () => {
    if (!selectedMainCategory || selectedCloverCategories.length === 0) {
      setMessage("Selecciona una categoría principal y al menos una categoría de Clover.");
      return;
    }

    try {
      const positionsPayload = selectedCloverCategories.reduce((acc, id) => {
        acc[id] = subcategoryPositions[id] || 0; // Corrige la estructura
        return acc;
      }, {});

      console.log("📌 Datos enviados a la API:", {
        cliente_id,
        cloverCategoryIds: selectedCloverCategories,
        positions: positionsPayload, // Verificar que esto está bien estructurado
      });

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000);

      const response = await fetch(
        `${API_BASE_URL}/categories/${selectedMainCategory}/subcategories`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cliente_id,
            cloverCategoryIds: selectedCloverCategories,
            positions: positionsPayload,
          }),
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutId);

      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

      console.log("✅ Respuesta exitosa de la API");
      setMessage("Subcategorías asignadas exitosamente.");
      fetchMainCategories();
      setShowModal(false);
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("⏳ La solicitud fue abortada por timeout.");
        setMessage("El servidor no respondió a tiempo. Intente nuevamente.");
      } else {
        console.error("❌ Error al asignar subcategorías:", error);
        setMessage("Error al asignar subcategorías.");
      }
    }
};

const uploadImage = async (categoryId) => {
  if (!image) {
    setMessage("Selecciona una imagen.");
    return;
  }

  const formData = new FormData();
  formData.append("image", image);

  try {
    const response = await fetch(
      `${API_BASE_URL}/categorias/${categoryId}/imagen?cliente_id=${cliente_id}`,
      { method: "POST", body: formData }
    );

    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

    const data = await response.json();
    console.log("✅ Respuesta de la API al subir imagen:", data);

    if (!data.path || typeof data.path !== "string") {
      throw new Error("La API no devolvió una URL válida para la imagen.");
    }

    // 🔥 Construimos la URL de la imagen sin caché
    const newImageUrl = ensureAbsoluteUrl(`${data.path}?t=${new Date().getTime()}`);

    // 🔥 ACTUALIZAMOS el estado de mainCategories correctamente
    setMainCategories((prevCategories) => {
      const updatedCategories = prevCategories.map((cat) =>
        cat.id === categoryId ? { ...cat, image_path: newImageUrl } : cat
      );
      console.log("🔄 Estado actualizado de categorías:", updatedCategories);
      return updatedCategories; // ⚡ React detecta el cambio
    });

    setImage(null);

    // ✅ Limpia el input de archivo
    const fileInput = document.querySelector(`#image-input-${categoryId}`);
    if (fileInput) {
      fileInput.value = "";
    }

    setMessage("Imagen subida exitosamente.");
  } catch (error) {
    console.error("❌ Error al subir imagen:", error);
    setMessage("Hubo un error al subir la imagen.");
  }
};


  const deleteCategory = async (categoryId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/categories/${categoryId}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error del backend:", errorData);
        throw new Error(`Error HTTP: ${response.status}`);
      }

      setMessage("Categoría eliminada correctamente.");

      setMainCategories((prevCategories) =>
        prevCategories.filter((cat) => cat.id !== categoryId)
      );
    } catch (error) {
      console.error("Error al eliminar categoría:", error);
      setMessage("Hubo un error al eliminar la categoría.");
    }
  };

  const removeSubcategory = async (categoryId, subcategoryId) => {
    try {
      console.log("Eliminando subcategoría:", categoryId, subcategoryId);

      const response = await fetch(
        `${API_BASE_URL}/categories/${categoryId}/subcategories/${subcategoryId}?cliente_id=${cliente_id}`,
        { method: "DELETE" }
      );

      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

      setMessage("Subcategoría eliminada correctamente.");

      setMainCategories((prevCategories) =>
        prevCategories.map((cat) =>
          cat.id === categoryId
            ? {
                ...cat,
                subcategories: cat.subcategories.filter(
                  (subcat) => subcat.clover_category_id !== subcategoryId
                ),
              }
            : cat
        )
      );
    } catch (error) {
      console.error("Error al eliminar subcategoría:", error);
      setMessage(`Error al eliminar subcategoría: ${error.message}`);
    }
  };

  const toggleCloverCategory = (categoryId) => {
    setSelectedCloverCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const syncCloverData = async () => {
    setLoading(true);
    setMessage("");
    try {
      if (!cliente_id) {
        setMessage("Cliente ID no encontrado.");
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_BASE_URL}/clover/sync-all`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cliente_id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error de la API:", errorData);
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log("Sincronización completada:", data);

      setMessage("Sincronización completada exitosamente.");
      fetchMainCategories();
      fetchProducts();
    } catch (error) {
      console.error("Error al sincronizar con Clover:", error);
      setMessage("Error al sincronizar con Clover.");
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/productos?cliente_id=${cliente_id}`);
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const data = await response.json();
      console.log("Productos actualizados:", data);
    } catch (error) {
      console.error("Error al obtener productos:", error);
      setMessage("Error al actualizar productos.");
    } finally {
      setLoading(false);
    }
  };
return (
  <div className="min-h-screen bg-gray-50 flex flex-col items-center py-8">
    <div className="w-full max-w-5xl px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-800 text-center mb-8">
        Gestión de Categorías
      </h1>
      {message && (
        <p className="text-center text-red-500 font-medium mb-4">{message}</p>
      )}
      {loading && <p className="text-center text-gray-600">Cargando...</p>}
      <div className="flex justify-center mb-8">
        <button
          onClick={syncCloverData}
          disabled={loading}
          className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition w-full sm:w-auto"
        >
          Sync Clover
        </button>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md mb-8">
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Crear Categoría Principal
        </h2>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <input
            type="text"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="Nombre de la categoría"
            className="w-full sm:flex-1 px-4 py-2 border rounded-md focus:ring focus:ring-indigo-300"
          />
          <button
            onClick={addMainCategory}
            className="w-full sm:w-auto px-6 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition"
          >
            Crear Categoría
          </button>
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-bold text-gray-800 mb-6">
          Categorías Principales
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {mainCategories && mainCategories.length > 0 ? (
            mainCategories.map((cat) => (
              <div
                key={cat.id}
                className="border rounded-lg p-4 bg-gray-50 shadow-md hover:shadow-lg transition"
              >
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {cat.name || "Sin nombre"}
                </h3>
                <img
                  src={
                    cat.image_path
                      ? cat.image_path.startsWith("http")
                        ? cat.image_path
                        : `${API_BASE_URL}/${cat.image_path}?t=${new Date().getTime()}`
                      : `${API_BASE_URL}/static/images/default-logo.png`
                  }
                  alt={cat.name || "Sin nombre"}
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <ul className="text-gray-600 mb-4">
                  {cat.subcategories && cat.subcategories.length > 0 ? (
                    cat.subcategories.map((subcat) => (
                      <li
                        key={subcat.clover_category_id || subcat.id}
                        className="flex justify-between items-center"
                      >
                        {subcat.name || "Sin nombre"}
                        <button
                          className="text-red-500 hover:underline"
                          onClick={() =>
                            removeSubcategory(cat.id, subcat.clover_category_id)
                          }
                        >
                          Eliminar
                        </button>
                      </li>
                    ))
                  ) : (
                    <li>Sin subcategorías asociadas</li>
                  )}
                </ul>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])}
                  className="block mb-4"
                />
                <button
                  onClick={() => uploadImage(cat.id)}
                  className="w-full px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition mb-2"
                >
                  Subir Imagen
                </button>
                <button
                  onClick={() => {
                    setSelectedMainCategory(cat.id);
                    setShowModal(true);
                  }}
                  className="w-full px-4 py-2 bg-yellow-500 text-white font-medium rounded-md hover:bg-yellow-600 transition mb-2"
                >
                  Añadir Subcategorías
                </button>
                <button
                  onClick={() => deleteCategory(cat.id)}
                  className="w-full px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition"
                >
                  Eliminar Categoría
                </button>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 col-span-full">
              No se encontraron categorías principales.
            </p>
          )}
        </div>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg h-full max-h-[90%] flex flex-col">
            <div className="p-4 border-b bg-gray-100 sticky top-0 z-10">
              <h2 className="text-lg font-bold text-gray-800 text-center">
                Seleccionar Subcategorías de Clover
              </h2>
            </div>
            <div className="flex-1 overflow-y-auto p-4">

{Array.isArray(cloverCategories) && cloverCategories.length > 0 ? (
  [...cloverCategories]
    .filter(cat => cat)  // ✅ Evita valores nulos/undefined
    .sort((a, b) => (a.position ?? Number.MAX_SAFE_INTEGER) - (b.position ?? Number.MAX_SAFE_INTEGER))
    .map((cat) => (
      <label
        key={cat.clover_category_id}
        className="flex items-center gap-2 mb-2"
      >
        <input
          type="checkbox"
          checked={selectedCloverCategories.includes(cat.clover_category_id)}
          onChange={() => toggleCloverCategory(cat.clover_category_id)}
          className="form-checkbox"
        />
        {cat.subcategoria_nombre || "Sin nombre"}
        <input
          type="number"
          min="1"
          className="border rounded px-2 py-1 w-16 text-center"
          placeholder="Pos."
          value={subcategoryPositions?.[cat.clover_category_id] ?? ""}
          onChange={(e) => {
            const newValue = Math.max(1, Number(e.target.value));
            handlePositionChange(cat.clover_category_id, newValue);
          }}
        />
      </label>
    ))
) : (
  <p className="text-gray-500 text-center">No hay categorías de Clover disponibles.</p>
)}

            </div>
            <div className="p-4 border-t bg-gray-100 flex justify-end gap-4 sticky bottom-0">
              <button
                onClick={assignSubCategories}
                className="px-6 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition"
              >
                Asignar
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="px-6 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition"
              >
                Cerrar
              </button>
             </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryManager;
